import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import PropertyForm from '../components/admin/PropertyForm';
import BlogForm from '../components/admin/BlogForm';
import BlogExportPanel from '../components/admin/BlogExportPanel';
import ImportPanel from '../components/admin/ImportPanel';
import AnalyticsPanel from '../components/admin/AnalyticsPanel';
import BlogStatsPanel from '../components/admin/BlogStatsPanel';
import QRCodesPanel from '../components/admin/QRCodesPanel';
import NewsletterPanel from '../components/admin/NewsletterPanel';
import LeadsPanel from '../components/admin/LeadsPanel';
import SharePreviewPanel from '../components/admin/SharePreviewPanel';
import GuidesPanel from '../components/admin/GuidesPanel';
import SettingsPanel from '../components/admin/SettingsPanel';
import s from '../components/admin/adminStyles';
import { useAuth } from '../context/AuthContext';

const TABS = [
  { key: 'analytics', label: 'Dashboard' },
  { key: 'leads', label: 'Leads' },
  { key: 'newsletter', label: 'Nieuwsbrief' },
  { key: 'guides', label: 'Gidsen' },
  { key: 'properties', label: 'Woningen' },
  { key: 'blog', label: 'Kennisbank' },
  { key: 'blog-stats', label: 'Blog Statistieken' },
  { key: 'blog-export', label: 'Blog Export' },
  { key: 'qr', label: 'QR codes' },
  { key: 'share-preview', label: 'Deel-preview' },
  { key: 'settings', label: 'Instellingen' },
  { key: 'import', label: 'Import' },
];

const Admin = () => {
  const [activeTab, setActiveTab] = useState('analytics');
  const { user, logout } = useAuth();

  return (
    <div style={s.page}>
      <div style={s.container}>
        <div style={titleRow}>
          <h1 style={s.title} data-testid="admin-title">Admin Dashboard</h1>
          <div style={userBox}>
            {user?.email && <span style={emailLabel}>{user.email}</span>}
            <button
              onClick={logout}
              style={logoutBtn}
              data-testid="admin-logout-button"
            >
              <LogOut size={16} />
              Uitloggen
            </button>
          </div>
        </div>

        <div className="admin-tabs-wrap" style={tabsWrap}>
          <div className="admin-tabs" style={s.tabs}>
            {TABS.map(tab => (
              <button
                key={tab.key}
                className="admin-tab"
                style={activeTab === tab.key ? s.tabActive : s.tab}
                onClick={() => setActiveTab(tab.key)}
                data-testid={`tab-${tab.key}`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {activeTab === 'properties' && <PropertyForm />}
        {activeTab === 'blog' && <BlogForm />}
        {activeTab === 'blog-stats' && <BlogStatsPanel />}
        {activeTab === 'blog-export' && <BlogExportPanel />}
        {activeTab === 'qr' && <QRCodesPanel />}
        {activeTab === 'share-preview' && <SharePreviewPanel />}
        {activeTab === 'leads' && <LeadsPanel />}
        {activeTab === 'newsletter' && <NewsletterPanel />}
        {activeTab === 'guides' && <GuidesPanel />}
        {activeTab === 'settings' && <SettingsPanel />}
        {activeTab === 'import' && <ImportPanel />}
        {activeTab === 'analytics' && <AnalyticsPanel />}
      </div>
      <style>{`
        .admin-tabs::-webkit-scrollbar { height: 3px; }
        .admin-tabs::-webkit-scrollbar-thumb { background: #EAE5DD; border-radius: 2px; }
        @media (max-width: 768px) {
          .admin-tabs-wrap {
            position: sticky;
            top: 0;
            z-index: 40;
            background: #FAF9F6;
            margin-left: -1.5rem;
            margin-right: -1.5rem;
            padding: 0 1.5rem;
            border-bottom: 1px solid #EAE5DD;
          }
          .admin-tabs {
            overflow-x: auto;
            flex-wrap: nowrap !important;
            gap: 0 !important;
            border-bottom: none !important;
            margin-bottom: 1.25rem !important;
            -webkit-overflow-scrolling: touch;
            scroll-snap-type: x proximity;
          }
          .admin-tab {
            flex: 0 0 auto;
            padding: 0.75rem 0.9rem !important;
            font-size: 0.85rem !important;
            white-space: nowrap;
            scroll-snap-align: start;
          }
        }
      `}</style>
    </div>
  );
};

const tabsWrap = {
  marginBottom: 0,
};

const titleRow = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '1rem',
  marginBottom: '2rem',
};

const userBox = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
};

const emailLabel = {
  color: '#8C8B88',
  fontSize: '0.875rem',
};

const logoutBtn = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem',
  backgroundColor: 'transparent',
  color: '#1A1918',
  border: '1px solid #EAE5DD',
  padding: '0.5rem 1rem',
  fontSize: '0.875rem',
  cursor: 'pointer',
  fontWeight: 500,
};

export default Admin;
